import { EmailTextInput, FloatingFormItem } from '@/components/_common';
import { MailConfigurationFormValues } from '@/core/domain/mail/MailConfigurationController/MailConfigurationController.types';
import { useDisclosure } from '@/hooks';
import {
  Button,
  Checkbox,
  Col,
  Form,
  FormInstance,
  Input,
  Row,
  Typography,
} from 'antd';
import React from 'react';
import { useIntl } from 'react-intl';

interface Props {
  form: FormInstance<MailConfigurationFormValues>;
  isExistingMail?: boolean;
  isProfile?: boolean;
}

const EmailSettingsForm: React.FC<Props> = (props) => {
  const intl = useIntl();

  const [showPasswordField, showPasswordFieldAction] = useDisclosure(false);

  return (
    <Form form={props.form} style={{ marginTop: '24px' }}>
      <Row gutter={[16, 8]}>
        <Col span={24} lg={12} xxl={6}>
          <FloatingFormItem
            name="mail"
            label="Conta"
            rules={[
              {
                type: 'email',
                message: intl.formatMessage({
                  id: 'commons.form.errors.invalidEmail',
                }),
              },
            ]}
          >
            <Input />
          </FloatingFormItem>
        </Col>

        <Col span={24} lg={12} xxl={6}>
          {props.isExistingMail && !showPasswordField ? (
            <Button
              type="link"
              onClick={showPasswordFieldAction.open}
              style={{ marginBottom: 12, paddingTop: 16 }}
            >
              Alterar senha
            </Button>
          ) : (
            <FloatingFormItem name="password" label="Senha do e-mail">
              <Input.Password visibilityToggle={false} />
            </FloatingFormItem>
          )}
        </Col>

        <Col span={24} lg={12} xxl={6}>
          <FloatingFormItem name="smtp" label="SMTP">
            <Input />
          </FloatingFormItem>
        </Col>

        <Col span={24} lg={12} xxl={6}>
          <FloatingFormItem name="port" label="Porta">
            <Input />
          </FloatingFormItem>
        </Col>

        <Col span={24} lg={12} xxl={6}>
          <Form.Item
            name="ssl"
            initialValue={false}
            valuePropName="checked"
            noStyle
          >
            <Checkbox style={{ marginTop: '12px' }}>
              Utilizar conexão segura (SSL)
            </Checkbox>
          </Form.Item>
        </Col>

        <Col span={24} lg={12}>
          <Form.Item
            name="tls"
            initialValue={false}
            valuePropName="checked"
            noStyle
          >
            <Checkbox style={{ marginTop: '12px' }}>
              Utilizar conexão segura (TLS)
            </Checkbox>
          </Form.Item>
        </Col>

        {props.isProfile && (
          <Col span={24} style={{ marginTop: '12px' }}>
            <Typography.Text>
              Crie uma assinatura que será adicionada automaticamente às suas
              mensagens do email.
            </Typography.Text>

            <Form.Item name="signature" style={{ marginTop: '12px' }}>
              <EmailTextInput style={{ height: 300 }} />
            </Form.Item>
          </Col>
        )}
      </Row>
    </Form>
  );
};

export default EmailSettingsForm;
